import * as React from "react";
import Box from "@mui/material/Box";
import { Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import ProductCategory from "./ProductCategory/ProductCategory";
import DietCategory from "./DietCategory/DietCategory";

export default function Setting() {
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "#fff",
            bgcolor: "#31AEF4",
            color: "#fff",
          }}
        >
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab
              sx={{ "&.Mui-selected": { color: "#fff",fontWeight: "bold" },color: "#fff" }}
              label="Product Category"
              value="1"
            />
            <Tab
              sx={{ "&.Mui-selected": { color: "#fff",fontWeight: "bold" },color: "#fff" }}
              label="Diet Category"
              value="2"
            />
          </TabList>
        </Box>
        <TabPanel value="1">
          <ProductCategory />
        </TabPanel>
        <TabPanel value="2">
          <DietCategory />
        </TabPanel>
      </TabContext>
    </Box>
  );
}
